export default "__VITE_ASSET__Bv9DHy14__"